/**
 * Mockup v3 P7 (Costos y modelos): the strings of a version's cost, the per-version breakdown of
 * Mi consumo and the catalogue picker of Modelos. Spread into `es` by `es.ts`; P7 adds its keys
 * here only. Copy from `mockup-ux-redesign-v3.html` (`verCost` and the `3 min` durations, the chip's
 * `v7 (actual) · …` tooltip, Detalles' `Coste de la v7`, `verBreakdown` and its toggle, `openPicker`
 * whose search is labelled «Buscar en el catálogo», the tier card). v3 has no sentence for an
 * unreadable catalogue or a model the catalogue does not price: those two say what the admin can
 * still do (type the model and its prices by hand, as before the catalogue).
 */
export const esCosts = {
  "cost.amount": "{currency} {amount}",
  "cost.none": "Sin coste",
  "cost.noneRestored": "Sin coste · restaurada",
  "cost.notCharged": "No se cobró",
  "cost.duration": "{minutes} min",
  "cost.chipTitle": "v{n} (actual) · {cost}",
  "cost.detailsTerm": "Coste de la v{n}",
  "cost.breakdown.title": "Coste de {name} por versión: tu consumo y el de todas las personas",
  "cost.breakdown.toggleColumn": "Desglose",
  "cost.breakdown.show": "Ver el coste por versión de {name}",
  "cost.breakdown.hide": "Ocultar el coste por versión de {name}",
  "cost.breakdown.version": "Versión",
  "cost.breakdown.when": "Cuándo",
  "cost.breakdown.what": "Qué cambió",
  "cost.breakdown.firstVersion": "Primera versión",
  "cost.breakdown.requestErased": "Mensaje eliminado",
  "cost.breakdown.duration": "Duración",
  "cost.breakdown.mine": "Mi consumo",
  "cost.breakdown.total": "Consumo total",
  "cost.breakdown.mockupTotal": "Total del mockup (desde el inicio, incluye versiones anteriores y respuestas de texto)",
  "cost.breakdown.pending": "Pendiente",
  "cost.breakdown.failedTurn": "Turno fallido",
  "cost.breakdown.reason.cancelled": "Se canceló antes de terminar",
  "cost.breakdown.reason.incomplete": "No se completó",
  "cost.breakdown.reason.timeout": "El modelo tardó más de lo permitido",
  "cost.breakdown.reason.providerUnavailable": "El proveedor del modelo no respondió",
  "cost.breakdown.reason.providerRejected": "El proveedor del modelo rechazó la petición",
  "cost.breakdown.reason.contextExceeded": "La petición era demasiado larga para el modelo",
  "cost.breakdown.reason.outOfCredits": "El proveedor del modelo se quedó sin saldo",
  "cost.breakdown.reason.outputTruncated": "La respuesta del modelo se cortó",
  "cost.breakdown.reason.invalidOutput": "La respuesta del modelo no se pudo usar",
  "cost.breakdown.older": "Y {count} versiones más antiguas.",
  "cost.breakdown.editorsOnly": "Solo quien puede editar este mockup ve su coste por versión.",
  "cost.breakdown.gone": "Este mockup ya no existe: su coste se conserva en el total.",
  "models.picker.open": "Buscar en el catálogo",
  "models.picker.help": "Elige del catálogo de OpenRouter; los precios se rellenan solos y puedes ajustarlos.",
  "models.picker.search": "Buscar por proveedor o modelo",
  "models.picker.list": "Modelos del catálogo",
  "models.picker.reasoningOnly": "Solo con razonamiento",
  "models.picker.reasoningBadge": "razonamiento",
  "models.picker.selected": "seleccionado",
  "models.picker.optionMeta": "{provider} · {model}",
  "models.picker.optionPrice": "{prompt} · {completion}",
  "models.picker.colModel": "Modelo",
  "models.picker.colContext": "Contexto",
  "models.picker.colOutput": "Salida",
  "models.picker.colPrice": "USD/M entrada · salida",
  "models.picker.foot": "Catálogo de OpenRouter · {count} modelos · actualizado {updated}",
  "models.picker.empty": "Ningún modelo coincide. Prueba con el proveedor (por ejemplo «google») o quita el filtro.",
  "models.picker.unavailable":
    "No se pudo leer el catálogo de OpenRouter. Puedes escribir el modelo y sus precios a mano, o volver a buscar más tarde.",
  "models.picker.filled": "Precios rellenados desde el catálogo",
  "models.picker.noPrice": "El catálogo no tiene precio para este modelo: escríbelo a mano.",
  "models.price.fromCatalogue": "del catálogo",
  "models.price.edited": "editado",
} as const;
